import { useEffect, useRef } from "react";

// минимальный скачок высоты viewport, чтобы считать это закрытием клавиатуры,
// а не мелким дрожанием адресной строки браузера
const KEYBOARD_HEIGHT_THRESHOLD = 150;

/**
 * Скроллит содержимое модалки наверх, когда закрывается виртуальная клавиатура
 * (высота window.visualViewport резко увеличивается).
 *
 * @param {boolean} isOpen — активен только пока модалка открыта
 * @param {React.RefObject<HTMLElement>} [targetRef] — что скроллить; без него скроллит window
 */
export default function useScrollUpOnKeyboardClose(isOpen, targetRef) {
  const lastHeightRef = useRef(window.visualViewport?.height ?? window.innerHeight);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!isOpen || !viewport) return undefined;

    lastHeightRef.current = viewport.height;

    const handleResize = () => {
      const prevHeight = lastHeightRef.current;
      const newHeight = viewport.height;
      lastHeightRef.current = newHeight;

      if (newHeight - prevHeight <= KEYBOARD_HEIGHT_THRESHOLD) return;

      const node = targetRef?.current;
      if (node) node.scrollTo({ top: 0, behavior: "smooth" });
      else window.scrollTo({ top: 0, behavior: "smooth" });
    };

    viewport.addEventListener("resize", handleResize);
    return () => viewport.removeEventListener("resize", handleResize);
  }, [isOpen, targetRef]);
}
